import { render } from "./UiTestMultiSelect.vue?vue&type=template&id=00ec6c6a"
import script from "./UiTestMultiSelect.vue?vue&type=script&lang=js"
export * from "./UiTestMultiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__